import React from "react";
import "./Dictionary_Popup.css"; 


const Popup = ({ item, onClose }) => {
    
    // If no item is passed, don't render popup
    if (!item) {
        return null;
    }

    return (
        <div className="PopupOverlay-dict" onClick={onClose}>
           
            <div className="Popup-dict" onClick={(e) => e.stopPropagation()}>
               
                <div className="popup-elements-container-dict">
                    
                    <div className="popup-banner-dict">
                       
                        <h2 className="popup-banner-txt-dict">{item.korean}</h2>
                   
                    </div>
                   
                    <p><strong>Romanization:</strong> {item.romanization}</p>
                    <p><strong>English:</strong> {item.english}</p>
                    
                    {/* Conditionally render the description if it exists */}
                   
                    {item.description && <p><strong>Description:</strong> {item.description}</p>}
               
                </div>
              
                <button onClick={onClose}>Close</button>
           
            </div>
       
        </div>
    );
};

export default Popup;
